module.exports = __webpack_public_path__ + "img/img1zhCn.4faf5a8b.png";